import { Tab, Nav } from "../../atoms/DependencyHelper";
import styles from "./homeTabs.module.scss";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Container } from "../../atoms/DependencyHelper";
import * as Analytics from "../../../services/analyticsUtag";
import { forceCheck } from 'react-lazyload';

const HomeTabs = ({ tabsContent, variant, tabType, alignment, className, analytics,selectedTab,selectTabHandler,page }) => {
  const [activeTab, setActiveTab] = useState(
    tabsContent.length ? tabsContent[0].title : "unknown"
  );
  const attributes = [
    "page_name",
  "page_channel",
  "page_master_tab",
  "visitor_login_status",
  "visitor_customer_id",
  "visitor_id_hash",
  "visitor_msisdn_hash",
  "visitor_subscription_type"
  ];
  const generateVariant = () => {
      return variant ? "tabs-design__nav--" + variant : "";
  };

  const generateAlignment = () => {
    switch (alignment) {
      case "left":
      case "LEFT":
        return alignment ? "tabs-design__nav--" + alignment.toLowerCase() : "";
        break;
      case "RIGHT":
      case "right":
        return alignment ? "tabs-design__nav--" + alignment.toLowerCase() : "";
        break;
      default:
        return "tabs-design__nav--";
    }
  };

  const generateTabType = () => {
    return tabType ? "tabs-design__nav--" + tabType : "";
  };

  const generateStyle = () => {
    const tabStyle = generateTabType();
    let variantStyle = "";
    if (tabType != "button") {
      variantStyle = generateVariant();
    }
    return `${tabStyle} ${variantStyle}`;
  };

  const generateTabLine = () =>{
    if (generateVariant() === ("tabs-design__nav--black-with-line" || "tabs-design__nav--red-with-line" )) {
      return true
    } 
  };

  const generatePageSpecificClass = () => {
    let style = "nav-alignment";
    if (page && page == "upgrade") {
      style = "";
    }
    return style;
  }

  useEffect(() => {
    if (selectedTab && page && page == "upgrade") {
      setActiveTab(selectedTab)
    }
  }, [selectedTab]);

  const handleTabChange = (eventKey) => {
    setActiveTab(eventKey);
    if (page && page == "upgrade") {
      selectTabHandler(eventKey);
    }
    const linkName = (analytics.link_name) ? `${analytics.link_name} ${eventKey}` : eventKey;
    Analytics.link({
      link_type: "o",
      page_tool_name: linkName,
      page_tool_event: "use",
      ...Analytics.getUtagData(attributes),
    });
    setTimeout(forceCheck, 1000);
  };

  return (
    <>
      {tabsContent.length > 0 && (
        <Tab.Container
          defaultActiveKey={tabsContent[0].title}
          activeKey={activeTab}
          onSelect={handleTabChange}
          mountOnEnter={true}
        >
          <div className={`${styles["home-tabs-container"]} `}>
            <Container className={styles[generateTabLine() && "underline"]}>
              <Nav
                variant="tabs"
                className={`${
                  styles["tabs-design__nav"]
                }  ${styles[generateVariant()]} ${styles[generateTabType()]} ${styles[generateAlignment()]} ${styles[generateStyle()]} ${styles[generatePageSpecificClass()]}`}
              >
                {tabsContent.map((tab, index) => (
                  <Nav.Item key={index}>
                    <Nav.Link id={tab.title}
                      eventKey={tab.title}
                      bsPrefix={`${styles["tab-link"]} ${
                        activeTab === tab.title
                          ? styles["tab-link--active"]
                          : ""
                      } ${(activeTab=="Past usage & spend" || tab.title=="Past usage & spend")?styles["past-usage-tab"]:""}`}
                      id={`${tab.title}_${index}`}
                    >
                      {tab.title}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Container>
            <div className={`${styles["tabs-design__content"]} ${page=="upgrade" ? styles["upgrade-custom"]:""}`}>
              <Tab.Content>
                {tabsContent.map((tab, index) => (
                  <Tab.Pane eventKey={tab.title} key={index}>
                    {tab.component}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      )}
    </>
  );
};

HomeTabs.propTypes = {
  tabsContent: PropTypes.array,
  variant: PropTypes.string,
  analytics: PropTypes.any,
};

HomeTabs.defaultProps = {
  tabsContent: [],
  variant: "home",
  analytics: {},
};

export default HomeTabs;